module.exports = __webpack_public_path__ + "common/icon-delete-bd115154daf31c15cb3612669d6ece3a.svg";